import { batch, signal } from "@preact/signals-react"
import { GLOBAL_EXECUTION_TABS } from "Pages/Admin/GlobalExecution/@constants"

export const tableReportData = signal([])
export const tableBatchData = signal([])
export const searchSummaryId = signal(null)
export const mustRequest = signal(true)
export const globalExecutionsTableReportCellData = signal({})
export const globalExecutionsTableBatchCellData = signal({})
export const adminIdStatusReportList = signal([])
export const adminIdStatusBatchList = signal([])
export const tabSelected = signal(GLOBAL_EXECUTION_TABS.REGULAR)
export const scraperSiteSelected = signal(null)
export const runningSearchesOpen = signal(false)

export const clearSignals = () => batch(() => {
	tableReportData.value = []
	tableBatchData.value = []
	searchSummaryId.value = null
	mustRequest.value = false
	globalExecutionsTableReportCellData.value = {}
	globalExecutionsTableBatchCellData.value = {}
	adminIdStatusReportList.value = []
	adminIdStatusBatchList.value = []
	scraperSiteSelected.value = null
	runningSearchesOpen.value = false
})